<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_bilgileri"  :show_button="false" @click="show"></ContentHeader>

<div class="mt-4">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.tedarikci_ismi" :value="audit.flowsupplier.supplier.name" valkey="name" @dataChanged="dataChanged" :read_only="true"></ClickEditInputText>

<ClickEditInputText  :title="$store.state.languages.lang_phrases.tedarikci_kodu" :value="audit.flowsupplier.supplier.suppliercode" valkey="suppliercode" @dataChanged="dataChanged" :read_only="true"></ClickEditInputText>

<ClickEditInputText  v-if="audit.auditor" :title="$store.state.languages.lang_phrases.denetci" :value="audit.auditor.user.name" valkey="name" :read_only="true" customcolor="#352f8d"></ClickEditInputText>

<ClickEditInputText  v-if="audit.scheduled_at" :title="$store.state.languages.lang_phrases.oturum_tarihi" :value="$filters.momentFormat(audit.scheduled_at,'DD-MM-YYYY')" valkey="name" :read_only="true" customcolor="#352f8d"></ClickEditInputText>



<template v-if="inputfieldclasses.length && !is_supplier">
	<ClickEditMultiSelect  title="Sınıfı" :value="audit.inputfieldclasses" :options="inputfieldclasses" valkey="inputfieldclasses" @dataChanged="auditClassUpdate"  />
</template>





<template v-for="attribute in audit.flowsupplier.flow.flowattributes">
<AuditCoverCustomattribute :attribute="attribute" @attributeChanged="attributeChanged" />
</template>




</div>

</div>
</template>

<script>
import AuditCoverCustomattribute from "./AuditCoverCustomattribute"
export default {

  name: 'AuditCover',

  data () {
    return {
    }
  },
  components:{AuditCoverCustomattribute},
  computed:{
  	is_supplier()
  	{  		
  		if(this.$store.state.auth.userroles.includes("supplier"))
  		{
  			return true
  		}
  		return false

  	},
  	audit()
  	{
  		return this.$store.state.audit.audit
  	},
  	inputfieldclasses()
  	{
  		if(this.$store.state.audit.audit.flowsupplier && this.$store.state.audit.audit.flowsupplier.flow.questionlist.inputfieldclasses.length)
  		{
  			return this.$store.state.audit.audit.flowsupplier.flow.questionlist.inputfieldclasses
  		}
  		return []
  	},
  	attribute_editable()
  	{
  		let user = this.$store.state.auth.user
  		if(user.userroles && user.userroles.length)
  		{
  			let userroles = user.userroles.map((element)=>{return element.name})
  			if(userroles.includes("admin"))
  			{
  				return false
  			}
  			if(userroles.includes("planner") || userroles.includes("brand") || userroles.includes("supplier"))
  			{
  				return true
  			}
  			if(userroles.includes("auditor"))
  			{
  				if(this.$store.state.audit.audit.status=="finished")
  				{
  					return true
  				}
  				else
  				{
  					return false
  				}
  				
  			}
  		}
  		return true
  	},
  },
  mounted()
  {
  	this.$store.dispatch('ui/setActiveTab',"kapak") 
  },
  methods:{
  	show()
  	{
  		console.log(this.audit)
  	},
  	auditClassUpdate(event)
  	{
  		console.log(event)
  		console.log(this.audit.inputfieldclasses)
  		let formdata = new FormData()
  		formdata.append("classes",JSON.stringify(event.value))
  		formdata.append("questionlist_id",this.audit.flowsupplier.flow.questionlist.id)
  		this.generalSubmission(formdata,"auditor_audits/update_audit_classes/"+this.audit.uuid,this.afterdataChanged)
  	},
  	dataChanged(data)
    {
    	console.log(data)
    	let formdata = new FormData()
    	formdata.append(data.key,data.value)
    	this.generalSubmission(formdata,"supplier/"+this.audit.flowsupplier.supplier.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
    	console.log(response.data)
    	this.getAuditData()
    	    	
    },
    async getAuditData()
    {
    	let data = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_data/"+this.$route.params.audit_uuid) 
  		await this.$store.dispatch('audit/setAudit',data.audit) 
  		await this.$store.dispatch('evaluation/setNullreasons',data.nullreasons) 
      await this.$store.dispatch('evaluation/setCustomattributes',data.customattributes) 
    },
    attributeChanged(data)
    {
    	
    	//return false
    	let formdata = new FormData()
    	if(data.attributetype=="multiselect")
    	{
    		formdata.append("data",JSON.stringify(data.value))
    	}
    	else
    	{
    		formdata.append("data",data.value)
    	}
    	
    	formdata.append("customattribute_id",data.key)
    	formdata.append("supplier_id",this.$route.params.id)
    	this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+this.audit.flowsupplier.supplier.id,this.afterdataChanged)
    },
  }
}
</script>

<style lang="css" scoped>
</style>